export type BoxDetection = {
  center: { x: number; y: number };
  min: { x: number; y: number };
  max: { x: number; y: number };
  confidence: number;
} | null;
